export default __webpack_public_path__ + "static/media/IMG_20220525_163537_466.8b020ee8.jpg";